// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zg5O","colMin":"styles_colMin__3C0VG"};